import { useState } from "react";
import clsx from "clsx";
import styles from "../../floorplans.module.scss";
import FloorplanCardSkelton from "./floorplanCardSkelton";

export default function FloorplanSkelton() {
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab")
      ? localStorage.getItem("activeTab") === "map"
        ? "grid"
        : localStorage.getItem("activeTab")
      : "grid"
  );

  return (
    <div className={styles.FloorplanSkeltonContainer}>
      <p className={styles.ResultsCount}>Loading Results</p>
      <div
        className={clsx(
          activeTab === "grid" && styles.FloorplanGridContainer,
          activeTab === "list" && styles.FloorplanListContainer
        )}
      >
        {Array.from({ length: 12 }, (_, index) => (
          <FloorplanCardSkelton key={index} activeTab={activeTab} />
        ))}
      </div>
    </div>
  );
}
